import React from 'react';
import { useNavigate } from 'react-router-dom';
import ContactData from '../contact-data';
import ProgressLabel from '../progress-label';
import { Element, ContainerProgress } from './styles';

const Department = ({ item }) => {
  const navigate = useNavigate();

  const handleNavigate = (id) => {
    navigate(`/prefeitura/secretaria/unidade/departamento/${id}`);
  };

  return (
    <Element onClick={() => handleNavigate(item.id)} id={`department-card-${item.id || 'unknown'}`}>
      <ContainerProgress id={`department-progress-${item.id || 'unknown'}`}>
        <ProgressLabel amount={item.compliance.maturity} />
      </ContainerProgress>
      <h1 id={`department-name-${item.id || 'unknown'}`}>{item.name}</h1>
      <small id={`department-responsible-${item.id || 'unknown'}`}>{item.responsible.name}</small>
      <div id={`department-contact-${item.id || 'unknown'}`}>
        {item.responsible.email && (
          <ContactData contact={item.responsible.email} />
        )}
      </div>
    </Element>
  );
};

export default Department;
